/**
 * Patient Notes GraphQL Service
 */
import ApolloClientService from './apolloclient.service'

const service = new ApolloClientService()

export default class PatientNotesService {
  /**
   * Get patient notes count only (efficient for dashboard display)
   */
  getPatientNotesCount = (patientId) => {
    return new Promise((resolve, reject) => {
      service
        .getPatientNotesCount(patientId)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          console.error('Error fetching patient notes count:', error)
          resolve({ status: 'error', message: error.message })
        })
    })
  }

  /**
   * Get patient notes with filtering
   */
  getPatientNotes = (input) => {
    return new Promise((resolve, reject) => {
      service
        .getPatientNotes(input)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          console.error('Error fetching patient notes:', error)
          resolve({ status: 'error', message: error.message })
        })
    })
  }

  /**
   * Get all patient notes categories
   */
  getPatientNotesCategories = () => {
    return new Promise((resolve, reject) => {
      service
        .getPatientNotesCategories()
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          console.error('Error fetching patient notes categories:', error)
          resolve({ status: 'error', message: error.message })
        })
    })
  }

  /**
   * Add new patient note
   */
  addPatientNote = (input) => {
    return new Promise((resolve, reject) => {
      service
        .addPatientNote(input)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          console.error('Error adding patient note:', error)
          resolve({ status: 'error', message: error.message })
        })
    })
  }

  /**
   * Update patient note
   */
  updatePatientNote = (input) => {
    return new Promise((resolve, reject) => {
      service
        .updatePatientNote(input)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          console.error('Error updating patient note:', error)
          resolve({ status: 'error', message: error.message })
        })
    })
  }

  /**
   * Delete patient note
   */
  deletePatientNote = (id) => {
    return new Promise((resolve, reject) => {
      service
        .deletePatientNote(id)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          console.error('Error deleting patient note:', error)
          resolve({ status: 'error', message: error.message })
        })
    })
  }
}